import { useContext } from 'react';
import Row from '../common/Row';

import { TableContext } from '../../TableContext';

export default function FooterRow({ children }) {
  const ctx = useContext(TableContext);

  return (
    <div>
      <Row withLines={ctx.withLines.footer}>{children}</Row>
    </div>
  );
}
